/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Documentation({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 16" {...props}><path stroke="currentColor" strokeWidth={1.2} d="M3.23 12.824v-9.26a2 2 0 0 1 2-2h6.523a2 2 0 0 1 2 1.995l.015 6.529a1 1 0 0 1-1 1.002H8.703" /><path fill="currentColor" d="M8.54 11.683h.6v-1.2h-.6v1.2Zm5.209 3.354a.6.6 0 0 0 0-1.2v1.2Zm-8.842-3.354h3.632v-1.2H4.907v1.2Zm8.842 2.154H4.907v1.2h8.842v-1.2Zm-8.842 0A1.077 1.077 0 0 1 3.83 12.76h-1.2a2.277 2.277 0 0 0 2.277 2.277v-1.2Zm0-3.354A2.277 2.277 0 0 0 2.63 12.76h1.2c0-.595.482-1.077 1.077-1.077v-1.2Z" /><path stroke="currentColor" strokeLinecap="round" strokeWidth={1.2} d="M13.516 10.781c-.72 1.25-.688 2.394.187 3.594M6.589 5.069h3.822" /></svg>;
}
;